import "./Footer.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <p>Yousef Gilany. If it breaks, I already know.</p>
      <span>2026</span>
    </footer>
  );
};

export default Footer;
